import { NetbankingAPI } from "aaa";
import * as _ from "lodash";
import { action, computed, observable } from "mobx";
import { IAccount } from "types/account";
import { NetbankingAPIClient } from "network/APIClient";
import { AccountsStore } from "./AccountsStore";

export const MAX_LINKED_ACCOUNTS = 3;

export class CardAccountsStore {
    accountStore = new AccountsStore();

    @observable originalLinkedAccounts: IAccount[] = [];
    @observable linkedAccounts: IAccount[] = [];
    @observable linkableAccounts: IAccount[] = [];

    @observable isLoading: boolean = false;

    @action async load(cardId: string) {
        const linked = NetbankingAPI.getLinkedAccounts(cardId);
        const linkable = NetbankingAPI.getLinkableAccounts(cardId);
        this.isLoading = true;

        try {
            const [unused, linkedResponse, linkableResponse] = await Promise.all([
                this.accountStore.load(),
                NetbankingAPIClient.requestType(linked),
                NetbankingAPIClient.requestType(linkable)
            ]);

            // Find linked Accounts
            const linkedAccounts = linkedResponse.linkedAccounts || [];
            this.linkedAccounts = _.compact(_.map(linkedAccounts, entry => this.accountStore.getAccountById(entry.accountId)));

            // Keep original linked accounts for changed check
            this.originalLinkedAccounts = [...this.linkedAccounts];

            // Find linkable Accounts
            const linkableAccounts = linkableResponse.linkableAccounts || [];
            this.linkableAccounts = _.compact(_.map([...linkableAccounts, ...linkedAccounts],
                entry => this.accountStore.getAccountById(entry.accountId)));

            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
            throw error;
        }
    }

    isAccountLinked(accountId: string) {
        return _.find(this.linkedAccounts, account => account.id === accountId) !== undefined;
    }

    @action linkAccount(accountId: string) {
        if (!this.isAccountLinked(accountId) && this.linkedAccounts.length < MAX_LINKED_ACCOUNTS) {
            const account = this.accountStore.getAccountById(accountId);
            if (account) {
                this.linkedAccounts = [...this.linkedAccounts, account];
            }
        }
    }

    @action unlinkAccount(accountId: string) {
        if (this.isAccountLinked(accountId)) {
            this.linkedAccounts = _.filter(this.linkedAccounts, account => account.id !== accountId);
        }
    }

    /**
     * Returns true if user has added or removed a linked account
     */
    @computed get linkedAccountsChanged() {
        const lengthChanged = this.linkedAccounts.length !== this.originalLinkedAccounts.length;
        // Either length change or content changed
        return lengthChanged || !_.isEqual(this.linkedAccounts.map(a => a.id).sort(), this.originalLinkedAccounts.map(a => a.id).sort());
    }

    @computed get newLinkedAccountIDs() {
        const linkedIDs = this.linkedAccounts.map(a => a.id);
        const originalLinkedIDs = this.originalLinkedAccounts.map(a => a.id);
        return _.difference(linkedIDs, originalLinkedIDs);
    }

    @computed get newUnlinkedAccountIDs() {
        const linkedIDs = this.linkedAccounts.map(a => a.id);
        const originalLinkedIDs = this.originalLinkedAccounts.map(a => a.id);
        return _.difference(originalLinkedIDs, linkedIDs);
    }
}


// WEBPACK FOOTER //
// ./src/stores/CardAccountsStore.ts